import { useState } from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import { IMAGES } from 'common/images';
import { PERSONAS } from 'common/constants';
import 'components/Modal/index.scss';

const getShareText = (link) =>
  // eslint-disable-next-line max-len
  `I've just signed up for Yodaa - The Smart Money App for Teens. Use my referral link and book a spot in line to receive an exclusive Yodaa invite! ${link}`;

export const StatusModal = (props) => {
  const [copied, setCopied] = useState(false);
  const { name, refsMade, position, link, isStatusCheck = false, type = PERSONAS.TEEN } = props;

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  };

  const onTwitterClick = () => {
    window.open(`http://twitter.com/intent/tweet?text=${encodeURI(getShareText(link))}`, '_blank');
  };
  const onWhatsappClick = () => {
    window.open(`https://wa.me/?text=${encodeURI(getShareText(link))}`, '_blank');
  };

  const getTitle = () => {
    if (isStatusCheck) {
      return 'Hey, there!';
    }
    return `Thanks for signing up, ${name}!`;
  };

  const getSubTitle = () => {
    if (isStatusCheck) {
      return "Been busy using your popularity to tell people about Yodaa? Let's see how well you've done";
    }
    return 'We have added you to our waitlist. Share your referral link with your friends to jump ahead 🚀';
  };

  if (type === PERSONAS.PARENT) {
    return (
      <Row>
        <Col className="text-center">
          <p className="form__title mb-4">Thanks for joining us!</p>
          <p className="form__subtitle mt-3">
            We&apos;ve added you to our waitlist. Please keep an eye on your inbox, our invites will
            start shipping super soon!
          </p>
          <p className="form__subtitle my-4">Excited about Yodaa? Tell your friends:</p>
          <Row className="justify-content-center align-items-center pt-3">
            <Image
              alt="whatsapp"
              src={IMAGES.WhatsApp}
              onClick={() => {
                const uniqueUrl = 'https://bit.ly/2GrhZy7';
                const string = `Empower your teen with the tools to master money. Sign up for Yodaa today! ${uniqueUrl}`;
                window.open(`https://wa.me/?text=${string}`, '_blank');
              }}
              className="status-modal__socials"
            />
            <Image
              alt="twitter"
              src={IMAGES.TwitterWhite}
              onClick={() => {
                const uniqueUrl = 'https://bit.ly/2ELI1ff';
                const string = `Empower your teen with the tools to master money. Sign up for Yodaa today! ${uniqueUrl}`;
                window.open(`http://twitter.com/intent/tweet?text=${encodeURI(string)}`, '_blank');
              }}
              className="status-modal__socials mx-4"
            />
            <Image
              alt="facebook"
              src={IMAGES.FacebookWhite}
              onClick={() => {
                const uniqueUrl = 'https://bit.ly/3cK3UZ1';
                window.open(
                  `http://www.facebook.com/sharer/sharer.php?u=${encodeURI(uniqueUrl)}`,
                  '_blank',
                );
              }}
              style={{ marginLeft: -12 }}
              className="status-modal__socials"
            />
          </Row>
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col className="text-center">
        <p className="form__title mb-4">{getTitle()}</p>
        <p className="form__subtitle my-4 mx-lg-5">{getSubTitle()}</p>
        <p className="form__subtitle">Your current waitlist status:</p>
        <Row className="my-4 mx-3 mx-md-5 align-items-center justify-content-center">
          <div style={{ marginRight: 24 }}>
            <p className="status-modal__position">{refsMade}</p>
            <p className="status-modal__position-title">Referrals made</p>
          </div>
          <div>
            <p className="status-modal__position">{position}</p>
            <p className="status-modal__position-title">Waitlist position</p>
          </div>
        </Row>
        <p className="status-modal__helper">Have your friends signup via this link to move ahead</p>
        <Row className="justify-content-center">
          <p className="status-modal__link my-4">{link}</p>
        </Row>
        <button type="button" onClick={onCopy} className="modal-form__submit">
          {copied ? 'Link Copied!' : 'Copy Link'}
        </button>
        <p className="form__subtitle my-4">or</p>
        <Row className="justify-content-center align-items-center">
          <Image
            alt="whatsapp"
            src={IMAGES.WhatsApp}
            onClick={onWhatsappClick}
            className="status-modal__socials mr-4"
          />
          <Image
            alt="twitter"
            src={IMAGES.TwitterWhite}
            onClick={onTwitterClick}
            className="status-modal__socials ml-4"
          />
        </Row>
      </Col>
    </Row>
  );
};
